import React from 'react';
import NavLink from './NavLink';

const NavLinkList = ({links}) => {
    return (
        <ul className="nav-link-list-wrapper">
            {links.map((route, i) => (
                <NavLink key={i} {...route} mobile={false}/>
            ))}
        </ul>
    )
}

export default NavLinkList;


// WEBPACK FOOTER //
// ./src/components/NavLinkList.js